export const LANGUAGE_INTEREST_EVENT = "language_interest_event";
